import React, { useState } from 'react';
import { Box, Button } from '@mui/material';

import { useStyles } from './styles';
import { IEventAsset } from '@providers/EventProvider/interfaces';

const MapContent = ({ maps }: { maps: IEventAsset[] }) => {
  const classes = useStyles();

  const [active, setActive] = useState<IEventAsset | null>(maps[0] || null);

  return (
    <Box sx={classes.root}>
      <Box sx={classes.actions}>
        {maps.map((floor) => (
          <Button
            key={floor.assetId}
            sx={classes.button(floor.assetId === active?.assetId)}
            onClick={() => setActive(floor)}
          >
            {floor.name}
          </Button>
        ))}
      </Box>

      <Box sx={classes.imageBox}>
        {active?.data?.url ? <img src={active.data.url} /> : null}
      </Box>
    </Box>
  );
};

export default MapContent;
